import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('CloudExercise', LATEST_SCHEMA_VERSION.CloudExercise);
export default exerciseTypeVersionAdapter;